import { render, staticRenderFns } from "./ShortVideoPromotion.vue?vue&type=template&id=79b8ca08&scoped=true&"
import script from "./ShortVideoPromotion.vue?vue&type=script&lang=js&"
export * from "./ShortVideoPromotion.vue?vue&type=script&lang=js&"
import style0 from "./ShortVideoPromotion.vue?vue&type=style&index=0&id=79b8ca08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8ca08",
  null
  
)

export default component.exports